window.getDevicePixelRatio = function () {
    var ratio = 1;
    // To account for zoom, change to use deviceXDPI instead of systemXDPI
    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI       !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
        // Only allow for values > 1
        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    }
    else if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    }
    return ratio;
};
function iOS() {
    return [
            'iPhone Simulator',
            'iPod Simulator',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
}

jQuery(document).ready(function($) {
    getVideos();
    var interval;
    $(window).resize(function () {
        clearTimeout(interval);
        interval = setTimeout(function() {
            getVideos();
        }, 500);
    });
    function getVideos() {
        var windowWidth = $(window).width();
        var devicePixelRatio = window.getDevicePixelRatio();
        $('[data-video-inject]').each(function() {
            var $video = $(this);
            var fallbackSources = $($(this).data('fallback')).html();
            var $sources = $($(this).data('video-inject'));
            $sources.find('>div').each(function() {
                var minWidth = $(this).data('min-width');
                var minPixelRatio = $(this).data('min-pixel-ratio');
                if (!minPixelRatio || devicePixelRatio >= minPixelRatio)
                {
                    if (!minWidth || windowWidth >= minWidth)
                    {
                        $(this).find('span').each(function() {
                            $video.append('<source type="'+$(this).data('type')+'" src="'+$(this).data('src')+'">');
                        });
                        $video[0].load();
                        return false;
                    }
                }
            });
        });
    }
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    if (iOS() || (params && params.debug && params.debug.toLowerCase() == 'iphone')) {
        $('body').addClass('ios');
    }
});